(function () {
	function format(count) {
		const n = Math.max(0, parseInt(count, 10) || 0);
		return "+" + n;
	}

	function setCount(el, count) {
		if (!el) return 0;
		const n = Math.max(0, parseInt(count, 10) || 0);
		el.setAttribute("data-ala-more-count", String(n));
		const label =
			el.querySelector(".ala-more-chip__label") ||
			el.querySelector(".facet-inline-pill__more-glyph") ||
			el.querySelector("[aria-hidden='true']");
		if (label) label.textContent = format(n);
		else if (!el.querySelector(".facet-inline-pill__less-glyph")) {
			el.textContent = format(n);
		}
		return n;
	}

	window.AlaMoreChip = { format: format, setCount: setCount };
})();
